<template>
  <div class="discount">
    <div class="mosi">
      <el-dialog :visible.sync="dialogVisible" width="510px" top='7vh' :before-close="handleClose" :show-close="false" :modal-append-to-body="false" class="dialoGclass" :class="dialogVisible ? 'FriendUrlCreateWindowFadeIn' : 'FriendUrlCreateWindowFadeOut'">
        <div slot="title" class="alertHeader dialogHeader">
          <img loading="lazy" class="cursorPoint dialogClose-header-img" style="width:40px;height:40px" v-lazy="require('../../static/image/pn/close.png')" @click="handleClose" />
          <div class="alertTitle dialogTitles" style="font-weight:normal;position:relative;top:2.4rem;color:#fff;font-size:22px">{{signIn.limitTime}}</div>
        </div>
        <div class="content">
          <el-scrollbar style="height:4rem;padding-right:2px">
            <ul>
              <li class="item-list" v-for="(item,i) of lists" :key="i" @click="openDetail(item)">
                <el-image :src="$common.getImgUrl(item.webPicture) ? $common.getImgUrl(item.webPicture) : img">
                  <!-- <div slot="placeholder" class="image-slot">
                                    {{signIn.loading}}
                                        <span class="dot">...</span>
                                    </div> -->
                </el-image>
              </li>
            </ul>
          </el-scrollbar>
          <div class="tips">
            <img loading="lazy" v-show="selectImg==false||selectImg=='false'" class="img-select" v-lazy="require('../../assets/images/yy/unchecked.png')" @click="onChange()" />
            <img loading="lazy" v-show="selectImg==true||selectImg=='true'" class="img-select" v-lazy="require('../../assets/images/yy/flagSelect.png')" @click="onChange()" />
            <span class="tips-text"> {{signIn.noShow}}</span>
          </div>
        </div>
      </el-dialog>
    </div>
    <TimeDiscountDetail ref="refTimeDiscountDetail"></TimeDiscountDetail>
    <Signin ref="refSignin" :SigninData="signinData"></Signin>
  </div>
</template>

<script>
import TimeDiscountDetail from "./TimeDiscountDetail";
import Signin from '../Signin/Signin'
import { showLogin } from '../../pages/login/login.js'
export default {
  components: {
    TimeDiscountDetail,
    Signin
  },
  data() {
    return {
      dialogVisible: false,
      selectImg: false,
      lists: [],
      img: require('../../assets/images/yy/bannerLoading.png'),
      signinData: {
        // signInRecordsVO:{},
      }
    };
  },
  watch: {
    //监听弹窗关闭打开
    dialogVisible(newValue, oldValue) {
      if (newValue) {
        this.selectImg = this.$cache.get("discount");
        if (this.selectImg == null || this.selectImg == "" || this.selectImg == undefined || this.selectImg == "false") {
          this.selectImg = false;
        }
      }
    },
  },
  created() {
    this.getTimeDiscount();
    if (this.$i18n.locale == 'zh_CN') {
      this.img = require('../../assets/images/yy/bannerLoading.png')
    } else {
      this.img = require('../../assets/images/yy/bannerLoading1.png')
    }
  },
  methods: {
    //获取限时优惠
    getTimeDiscount() {
      this.$http.post(this.$api.getThematicActivitiesListByApp, "", true)
        .then((res) => {
          if (res.code == 0) {
            this.lists = res.data.content;
            this.onTimeDiscount()
          }
        });
    },
    //限时优惠
    onTimeDiscount() {
      this.$emit("openFloat", this.lists);
    },
    //点击某一项触发事件
    openDetail(item) {
      let token = this.$store.state.token
      if (!token) {
        showLogin({
          show: true
        })
        this.dialogVisible = false;
        return
      }
      this.$http.get(this.$api.getThematicActivitiesByApp + "/" + item.id, "", true).then((res) => {
        if (res.code == 0) {
          if (item.type == 2) {  //签到
            this.signinData = res.data;
            this.$refs.refSignin.centerDialogVisible = true;
            this.dialogVisible = false;
          } else {  //限时优惠详情
            this.$refs.refTimeDiscountDetail.pageData = res.data;
            this.$refs.refTimeDiscountDetail.dialogVisible = true;
          }

        }
      });

    },
    //是否不再显示切换事件
    onChange() {
      this.selectImg = !this.selectImg;
      if (this.selectImg) {
        this.$cache.set("discount", true);
      } else {
        this.$cache.set("discount", false);
      }
    },
    //弹窗关闭事件
    handleClose() {
      this.dialogVisible = false;
      if (this.$common.getUser()) {
        this.$store.commit('advertisingShow', 1);
      }
    },
  },
  computed: {
    signIn() {
      return this.$t('signIn')
    }
  },
  watch: {
    '$i18n.locale'(val) {
      if (this.$i18n.locale == 'zh_CN') {
        this.img = require('../../assets/images/yy/bannerLoading.png')
      } else {
        this.img = require('../../assets/images/yy/bannerLoading1.png')
      }
    }
  }
};
</script>

<style lang="scss" >
.discount {
  // @import "../../assets/css/eldialog.scss";
  .mosi .el-dialog {
    // background-image: url("../../assets/images/yy/signBgc.png");
    background-size: 100% 100%;
    background-color: transparent;
    box-shadow: none;
  }
  .el-scrollbar__wrap {
    text-align: center;
  }
  .content {
    min-height: 4.3rem;
    margin-top: 2.4rem;
    .item-list {
      width: 100%;
      margin-bottom: 15px;
      cursor: pointer;
      .el-image {
        border-radius: 10px;
        width: 428px;
        height: 150px;
        overflow: hidden;
        .image-slot {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 150px;
          background: #f5f7fa;
          color: #909399;
          font-size: 14px;
        }
        .dot {
          animation: dot 2s steps(3, start) infinite;
          overflow: hidden;
        }
        .el-image__error {
          min-height: 150px;
        }
      }
    }
  }
  .tips {
    text-align: center;
    margin-top: 20px;
    .img-select {
      width: 20px;
      z-index: 2;
      cursor: pointer;
      margin-right: 10px;
      vertical-align: middle;
    }
    .tips-text {
      vertical-align: middle;
      color: #fff;
    }
  }
  .FriendUrlCreateWindowFadeIn {
    animation: FadeIn1 0.5s linear;
  }
  .FriendUrlCreateWindowFadeOut {
    animation: FadeOut1 0.5s linear;
  }

  @keyframes FadeIn1 {
    0% {
      transform: scale(0);
      transform-origin: right 35%;
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes FadeOut1 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
      transform-origin: right 35%;
    }
  }

  // .el-dialog__wrapper {
  // 	transition-duration: 0.3s;
  // }
  // .dialog-fade-enter-active{
  // 	animation: none !important;
  // }
  // .dialog-fade-leave-active {
  // 	transition-duration: 0.5s !important;
  // 	animation: none !important;
  //   }

  // .dialog-fade-enter-active .el-dialog,
  // .dialog-fade-leave-active .el-dialog{
  // 	animation-fill-mode: forwards;
  // }

  // .dialog-fade-enter-active .el-dialog{
  // 	animation-duration: 0.3s;
  // 	animation-name: anim-open;
  //     animation-timing-function: linear;//cubic-bezier(0.6,0,0.4,1);
  //     transform:translate(1000px,20px)

  // }

  // .dialog-fade-leave-active .el-dialog{
  // 	animation-duration: 0.3s;
  //     animation-name: anim-close;
  //     animation-timing-function: linear;
  // }

  // @keyframes anim-open {
  //     0% { opacity: 0;   transform:scale(1);
  //         transform: translateX(400px);
  //     }
  //     50%{ opacity: 0.2; transform:scale(1)}
  //     100% { opacity: 1;  transform:scale(1);
  //         transform: translateX(0px);
  //         transform: scale3d(0.5, 0.5, 1);
  //     }
  // }

  // @keyframes anim-close {
  //     0% { opacity: 1; }
  //     50%{ opacity: 0.5; }
  // 	100% { opacity: 0; transform: scale3d(0.5, 0.5, 1); }
  // }
}
</style>